import { useEffect, useState } from "react";
import type { DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../../../shared/components/ModalBasic";
import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import { TModalsIds } from "../../../../../app/state/modalSlice/types";
import { TDirection } from "../../../types";
import { ModalHeader } from "./components/ModalHeader";
import { DirectionMenu } from "./components/ModalHeader/DirectionMenu";
import { useAppMenus } from "../../../../../app/state/menuSlice/hook/use-app-menus";
import { ModalBody } from "./components/ModalBody";
import { selectSkills } from "../../../redux/selectors";
import { useAppDispatch } from "../../../../../services/redux/hooks/use-dispatch";
import { getAssistantSkillsAction } from "../../../redux/actions";
import { useModalSelectors } from "../../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  closeModal: (id: TModalsIds) => void;
}

export const AgentAssistantsModal = (props: Props) => {
  const dispatch = useAppDispatch();
  const agentAssistantsModal = useModalSelectors("agent_assistants_modal");
  const [direct, setDirect] = useState<TDirection>("top");
  const { handleOpenMenu, handleCloseMenu } = useAppMenus();
  const skills = useAppSelector(selectSkills);
  const { t } = useTranslation();

  useEffect(() => {
    if (agentAssistantsModal.isOpen) {
      dispatch(getAssistantSkillsAction());
    }
  }, [agentAssistantsModal.isOpen]);
  return (
    <ModalBasic
      open={agentAssistantsModal.isOpen}
      onClose={() => props.closeModal("agent_assistants_modal")}
      closeModal={() => props.closeModal("agent_assistants_modal")}
    >
      <div className={styles.body}>
        <ModalHeader direction={direct} handleClick={handleOpenMenu} />
        <ModalBody skills={skills} direction={direct} />
      </div>
      <DirectionMenu
        direction={direct}
        handleClick={setDirect}
        handleClose={handleCloseMenu}
      />
    </ModalBasic>
  );
};
